/** One list, so a mutation can refresh everything it may have changed. */
export const queryKeys = {
  me: ['me'],
  trackedPlayers: ['tracked-players'],
  games: ['games'],
  rules: ['rules'],
  wagers: ['wagers'],
  users: ['users'],
  ledger: ['ledger'],
  work: ['work'],
} as const;

/** The poller runs every few minutes; checking once a minute shows its results soon enough. */
export const REFRESH_INTERVAL_MS = 60_000;
